import { DatePicker, Input, message, Table } from "antd";
import Toolbar from "../common/Toolbar";
import dayjs from "dayjs";
import { date2locale, formatDateTime } from "../common/common";
import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../common/api";
import { UserInfoContext } from "../FetchUserInfo";
import NewAttendanceRawRecord from "./NewAttendanceRawRecord";
import EditAttendanceRawRecord from "./EditAttendanceRawRecord";
import FilterRow from "../components/filter/FilterRow";
import TablePage from "../components/TablePage";

const columns = [
    {
        key: "employee",
        title: "Dipendente",
        dataIndex: ["employee", "fullName"],
        width: 100,
    },
    {
        title: "Data e ora",
        key: "timestamp",
        dataIndex: "timestamp",
        width: 100,
        render: formatDateTime,
    },
    {
        title: "Provenienza",
        key: "src",
        dataIndex: "source",
        width: 100,
    },
];

const filterItems = [
    {
        name: "query",
        label: "Dipendente",
        formItem: {
            children: <Input />,
        },
    },
    {
        name: "range",
        label: "Date",
        readableValue: (value) =>
            `Dal ${date2locale(value.split("_")[0])} al ${date2locale(value.split("_")[1])}`,
        formItem: {
            children: <DatePicker.RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />,
            props: {
                getValueProps: (value) => ({
                    value: value ? [dayjs(value.split("_")[0]), dayjs(value.split("_")[1])] : [],
                }),
                normalize: (value) =>
                    value.length === 2 &&
                    value[0].format("YYYY-MM-DD") + "_" + value[1].format("YYYY-MM-DD"),
            },
        },
    },
    {
        name: "source",
        label: "Provenienza",
        formItem: {
            children: <Input />,
        },
    },
];

export default function () {
    const [selectedKey, setSelectedKey] = useState();
    const user = useContext(UserInfoContext);
    const navigate = useNavigate();

    const fetch = (params) => {
        if (params.range) {
            params.startDate = params.range.split("_")[0];
            params.endDate = params.range.split("_")[1];
            delete params.range;
        }
        return axiosInstance.get("attendanceRawRecord", { params });
    };

    return (
        <div>
            <TablePage
                columns={columns}
                filterItems={filterItems}
                fetchFunction={fetch}
                rowSelectionType="radio"
                onSelectedKeysChange={(keys) => setSelectedKey(keys.length === 1 ? keys[0] : null)}
                toolbarProps={(refresh) => ({
                    addAction: user?.permissions.includes("attendanceRawRecord.create")
                        ? () => navigate("new")
                        : null,
                    editAction: user?.permissions.includes("attendanceRawRecord.update")
                        ? (key) => {
                              navigate(`${key}/edit`);
                              //if (result.data.filter((x) => x.id === key)[0].createdByThirdParty)
                              //else message.warning("Timbratura non modificabile");
                          }
                        : null,
                    deleteAction: user?.permissions.includes("attendanceRawRecord.delete")
                        ? (keys) => {
                              //if (
                              //      result.data.filter((x) => x.id === keys[0])[0].createdByThirdParty
                              // ) {
                              axiosInstance.delete(`attendanceRawRecord/${keys[0]}`).then(refresh);
                              // } else message.warning("Timbratura non eliminabile");
                          }
                        : null,
                })}
            />
        </div>
    );
}
